import Barcode from "../Barcode.js";
import { SHIFT, SET_A, SET_B, MODULO, STOP, FNC1, SET_BY_CODE, SWAP, BARS } from "./constants";
class CODE128 extends Barcode {
  constructor(data, options) {
    super(data.substring(1), options);
    this.bytes = data.split("").map((char) => char.charCodeAt(0));
  }
  valid() {
    return /^[\x00-\x7F\xC8-\xD3]+$/.test(this.data);
  }
  // The public encoding function
  encode() {
    const bytes = this.bytes;
    const startIndex = bytes.shift() - 105;
    const startSet = SET_BY_CODE[startIndex];
    if (startSet === void 0) {
      throw new RangeError("The encoding does not start with a start character.");
    }
    if (this.shouldEncodeAsEan128() === true) {
      bytes.unshift(FNC1);
    }
    const encodingResult = CODE128.next(bytes, 1, startSet);
    return {
      text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, "") : this.text,
      data: (
        // Add the start bits
        CODE128.getBar(startIndex) + // Add the encoded bits
        encodingResult.result + // Add the checksum
        CODE128.getBar((encodingResult.checksum + startIndex) % MODULO) + // Add the end bits
        CODE128.getBar(STOP)
      )
    };
  }
  // GS1-128/EAN-128
  shouldEncodeAsEan128() {
    let isEAN128 = this.options.ean128 || false;
    if (typeof isEAN128 === "string") {
      isEAN128 = isEAN128.toLowerCase() === "true";
    }
    return isEAN128;
  }
  // Get a bar symbol by index
  static getBar(index) {
    return BARS[index] ? BARS[index].toString() : "";
  }
  // Correct an index by a set and shift it from the bytes array
  static correctIndex(bytes, set) {
    if (set === SET_A) {
      const charCode = bytes.shift();
      return charCode < 32 ? charCode + 64 : charCode - 32;
    } else if (set === SET_B) {
      return bytes.shift() - 32;
    } else {
      return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
    }
  }
  static next(bytes, pos, set) {
    if (!bytes.length) {
      return { result: "", checksum: 0 };
    }
    let nextCode, index;
    if (bytes[0] >= 200) {
      index = bytes.shift() - 105;
      const nextSet = SWAP[index];
      if (nextSet !== void 0) {
        nextCode = CODE128.next(bytes, pos + 1, nextSet);
      } else {
        if ((set === SET_A || set === SET_B) && index === SHIFT) {
          bytes[0] = set === SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
        }
        nextCode = CODE128.next(bytes, pos + 1, set);
      }
    } else {
      index = CODE128.correctIndex(bytes, set);
      nextCode = CODE128.next(bytes, pos + 1, set);
    }
    const enc = CODE128.getBar(index);
    const weight = index * pos;
    return {
      result: enc + nextCode.result,
      checksum: weight + nextCode.checksum
    };
  }
}
var stdin_default = CODE128;
export {
  stdin_default as default
};
